import "flowbite";
import { delay } from "./js/utils";
import { customLogin } from "./js/customLogin";
import { passwordToggleVisibility } from "./js/passwordToggleVisibility";
import { createTeacher } from "./js/createTeacher";
import { createStudent } from "./js/createStudent";
import { updateStudent } from "./js/updateStudent";
import { updateTeacher } from "./js/updateTeacher";
import { deleteTeacher } from "./js/deleteTeacher";
import { createAssessment } from "./js/createAssessment";
import { createCSV } from "./js/createCSV";
import { filterAssessmentResults } from "./js/filterAssessmentResults";
import { stripNaughtyWords } from "./js/swear";
import { sortTable } from "./js/sortTable";
import { removeStudents } from "./js/removeStudents";

// DOM Ready
window.addEventListener("load", (e) => {

  // preloader
  delay(500).then(() => {
    document.body.classList.remove("loading");
  });

  // create teacher
  createTeacher();

  // update teacher
  updateTeacher();

  // create student
  createStudent();

  // update student
  updateStudent();

  // toggle password visibiilty
  passwordToggleVisibility();

  // login
  customLogin();

  // assessment
  createAssessment();

  // export as csv
  createCSV();

  // filter assessments
  filterAssessmentResults();

   // delete a teacher
   deleteTeacher();

  // table filtering
  sortTable();

  // remove students
  removeStudents();

  // loop through input text
  const fields = document.querySelectorAll('input[type="text"], input[type="password"]');
  if(fields){
    fields.forEach(field => stripNaughtyWords(field));
  }

});
